import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetPartsDeliveryCountsQueryVariables = Types.Exact<{
  scope: Types.Mobility_Runs_Bool_Exp;
  window: Types.Mobility_Runs_Bool_Exp;
}>;


export type GetPartsDeliveryCountsQuery = { __typename?: 'query_root', upcoming: { __typename?: 'mobility_runs_aggregate', aggregate?: { __typename?: 'mobility_runs_aggregate_fields', count: number } | null }, active: { __typename?: 'mobility_runs_aggregate', aggregate?: { __typename?: 'mobility_runs_aggregate_fields', count: number } | null }, completed: { __typename?: 'mobility_runs_aggregate', aggregate?: { __typename?: 'mobility_runs_aggregate_fields', count: number } | null }, cancelled: { __typename?: 'mobility_runs_aggregate', aggregate?: { __typename?: 'mobility_runs_aggregate_fields', count: number } | null } };


export const GetPartsDeliveryCountsDocument = gql`
    query getPartsDeliveryCounts($scope: mobility_runs_bool_exp!, $window: mobility_runs_bool_exp!) {
  upcoming: mobility_runs_aggregate(
    where: {product_type: {_eq: "parts_delivery"}, _and: [$scope, $window, {_or: [{_and: [{_or: [{fulfillment_type: {_is_null: true}}, {fulfillment_type: {_neq: "external_courier"}}, {parts_delivery_id: {_is_null: true}}]}, {_or: [{status: {_is_null: true}}, {status: {_nin: ["in_transit", "completed", "cancelled", "canceled"]}}]}]}, {_and: [{fulfillment_type: {_eq: "external_courier"}, parts_delivery_id: {_is_null: false}}, {parts_delivery: {_or: [{orchestration_status: {_in: ["NEW", "PENDING", "BOOKING", "RETRY"]}}, {_and: [{_or: [{orchestration_status: {_is_null: true}}, {orchestration_status: {_nin: ["NEW", "PENDING", "BOOKING", "RETRY", "FAILED"]}}]}, {_or: [{delivery_status: {_is_null: true}}, {delivery_status: {_nin: ["arriving_pickup", "picked_up", "arriving_dropoff", "return_in_progress", "delivered", "canceled", "returned"]}}]}]}]}}]}]}]}
  ) {
    aggregate {
      count
    }
  }
  active: mobility_runs_aggregate(
    where: {product_type: {_eq: "parts_delivery"}, _and: [$scope, $window, {_or: [{_and: [{_or: [{fulfillment_type: {_is_null: true}}, {fulfillment_type: {_neq: "external_courier"}}, {parts_delivery_id: {_is_null: true}}]}, {status: {_in: ["in_transit"]}}]}, {_and: [{fulfillment_type: {_eq: "external_courier"}, parts_delivery_id: {_is_null: false}}, {parts_delivery: {_and: [{_or: [{orchestration_status: {_is_null: true}}, {orchestration_status: {_nin: ["NEW", "PENDING", "BOOKING", "RETRY", "FAILED"]}}]}, {delivery_status: {_in: ["arriving_pickup", "picked_up", "arriving_dropoff", "return_in_progress"]}}]}}]}]}]}
  ) {
    aggregate {
      count
    }
  }
  completed: mobility_runs_aggregate(
    where: {product_type: {_eq: "parts_delivery"}, _and: [$scope, $window, {_or: [{_and: [{_or: [{fulfillment_type: {_is_null: true}}, {fulfillment_type: {_neq: "external_courier"}}, {parts_delivery_id: {_is_null: true}}]}, {status: {_in: ["completed"]}}]}, {_and: [{fulfillment_type: {_eq: "external_courier"}, parts_delivery_id: {_is_null: false}}, {parts_delivery: {_and: [{_or: [{orchestration_status: {_is_null: true}}, {orchestration_status: {_nin: ["NEW", "PENDING", "BOOKING", "RETRY", "FAILED"]}}]}, {delivery_status: {_in: ["delivered"]}}]}}]}]}]}
  ) {
    aggregate {
      count
    }
  }
  cancelled: mobility_runs_aggregate(
    where: {product_type: {_eq: "parts_delivery"}, _and: [$scope, $window, {_or: [{_and: [{_or: [{fulfillment_type: {_is_null: true}}, {fulfillment_type: {_neq: "external_courier"}}, {parts_delivery_id: {_is_null: true}}]}, {status: {_in: ["cancelled", "canceled"]}}]}, {_and: [{fulfillment_type: {_eq: "external_courier"}, parts_delivery_id: {_is_null: false}}, {parts_delivery: {_or: [{orchestration_status: {_eq: "FAILED"}}, {_and: [{_or: [{orchestration_status: {_is_null: true}}, {orchestration_status: {_nin: ["NEW", "PENDING", "BOOKING", "RETRY", "FAILED"]}}]}, {delivery_status: {_in: ["canceled", "returned"]}}]}]}}]}]}]}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetPartsDeliveryCountsQuery__
 *
 * To run a query within a React component, call `useGetPartsDeliveryCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartsDeliveryCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartsDeliveryCountsQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *      window: // value for 'window'
 *   },
 * });
 */
export function useGetPartsDeliveryCountsQuery(baseOptions: Apollo.QueryHookOptions<GetPartsDeliveryCountsQuery, GetPartsDeliveryCountsQueryVariables> & ({ variables: GetPartsDeliveryCountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartsDeliveryCountsQuery, GetPartsDeliveryCountsQueryVariables>(GetPartsDeliveryCountsDocument, options);
      }
export function useGetPartsDeliveryCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartsDeliveryCountsQuery, GetPartsDeliveryCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartsDeliveryCountsQuery, GetPartsDeliveryCountsQueryVariables>(GetPartsDeliveryCountsDocument, options);
        }
// @ts-ignore
export function useGetPartsDeliveryCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPartsDeliveryCountsQuery, GetPartsDeliveryCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartsDeliveryCountsQuery, GetPartsDeliveryCountsQueryVariables>;
export function useGetPartsDeliveryCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartsDeliveryCountsQuery, GetPartsDeliveryCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartsDeliveryCountsQuery | undefined, GetPartsDeliveryCountsQueryVariables>;
export function useGetPartsDeliveryCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartsDeliveryCountsQuery, GetPartsDeliveryCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPartsDeliveryCountsQuery, GetPartsDeliveryCountsQueryVariables>(GetPartsDeliveryCountsDocument, options);
        }
export type GetPartsDeliveryCountsQueryHookResult = ReturnType<typeof useGetPartsDeliveryCountsQuery>;
export type GetPartsDeliveryCountsLazyQueryHookResult = ReturnType<typeof useGetPartsDeliveryCountsLazyQuery>;
export type GetPartsDeliveryCountsSuspenseQueryHookResult = ReturnType<typeof useGetPartsDeliveryCountsSuspenseQuery>;
export type GetPartsDeliveryCountsQueryResult = Apollo.QueryResult<GetPartsDeliveryCountsQuery, GetPartsDeliveryCountsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * Multiple root fields (upcoming, active, completed, cancelled): returns the full response object.
 * @source {@link src/features/partsDelivery/counts/getPartsDeliveryCounts.query.gql}
 */
export async function getPartsDeliveryCounts(
  variables: GetPartsDeliveryCountsQueryVariables,
  options?: { executor?: GqlExecutor } & GqlRequestOptions
): Promise<GetPartsDeliveryCountsQuery> {
  const { executor, ...requestOptions } = options ?? {}
  return resolveExecutor(executor).query<GetPartsDeliveryCountsQuery>(
    GetPartsDeliveryCountsDocument,
    variables,
    requestOptions
  )
}